import { getState } from "./State.routes";
import { get } from "../index";

const states = {
  gettingState: async (id) => {
    const result = await get(getState.gettingState + `/${id}`);
    return result;
  },
};

export default states;
